import dayjs from "dayjs";
import { jwtDecode } from "jwt-decode";
import { MiddlewareCallbackParams } from "openapi-fetch";
import {
  getLegacyRefreshToken,
  getRefreshTokenFromOldAccess,
} from "./utils";

export async function requestAuthMiddleware(
  request: MiddlewareCallbackParams["request"],
) {
  if (request.url.includes("/tokens/jwt/refresh")) return request;

  const legacyAccessTokenLocal = localStorage.getItem("token");
  const accessTokenLocal = localStorage.getItem("newToken");

  // если токена второй версии ещё нет.
  if (legacyAccessTokenLocal && !accessTokenLocal) {
    const { accessToken } = await getRefreshTokenFromOldAccess(
      legacyAccessTokenLocal,
    );
    if (accessToken) {
      localStorage.setItem("newToken", accessToken);
    }
  }

  if (legacyAccessTokenLocal) {
    const { exp: legacyExp } = jwtDecode(legacyAccessTokenLocal);
    if (dayjs().isAfter(dayjs.unix(legacyExp ?? 0))) {
      const newLegacyAccessToken = await getLegacyRefreshToken(
        legacyAccessTokenLocal,
      );
      localStorage.setItem("token", newLegacyAccessToken);
    }

    const newLegacyAccessToken = localStorage.getItem("token")!;

    // Check if the new token exists before trying to decode it
    if (accessTokenLocal) {
      const { exp } = jwtDecode(accessTokenLocal);
      if (dayjs().isAfter(dayjs.unix(exp ?? 0))) {
        const { accessToken } = await getRefreshTokenFromOldAccess(
          newLegacyAccessToken,
          accessTokenLocal,
        );
        if (accessToken) {
          localStorage.setItem("newToken", accessToken);
        }
      }
    }

    /*
     * Чтобы не повторяться каждый раз и не присваивать Auth header
     * при каждом случае выше. Надеемся на кеширование со стороны браузера
     * */
    const resultToken = localStorage.getItem("newToken");
    const resultLegacyToken = localStorage.getItem("token");

    request.headers.set("Authorization", `Bearer ${resultToken}`);
    request.headers.set("x-auth", `${resultLegacyToken}`);
  }

  return request;
}
